import { Link } from "react-router-dom";
import logoLight from "@/assets/logo-light.png";
import { useLocale } from "@/contexts/LocaleContext";

const Footer = () => {
  const { t, locale } = useLocale();
  const isPt = locale.language === "pt";

  const links = {
    platform: [
      { name: t("nav.events"), href: "#events" },
      { name: t("nav.leaderboard"), href: "#leaderboard" },
    ],
    company: [
      { name: isPt ? "Sobre" : "About", href: "/about" },
    ],
    legal: [
      { name: isPt ? "Privacidade" : "Privacy", href: "/privacy" },
      { name: isPt ? "Termos" : "Terms", href: "/terms" },
    ],
  };

  return (
    <footer className="border-t border-border/50 bg-card/30">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Logo & Description */}
          <div className="col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img src={logoLight} alt="Callyout" className="h-8 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm mb-4 max-w-xs">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Platform Links */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">{t("footer.platform")}</h4>
            <ul className="space-y-2">
              {links.platform.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-muted-foreground hover:text-foreground text-sm transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">{t("footer.company")}</h4>
            <ul className="space-y-2">
              {links.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-muted-foreground hover:text-foreground text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">{t("footer.legal")}</h4>
            <ul className="space-y-2">
              {links.legal.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-muted-foreground hover:text-foreground text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border/50 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            © {new Date().getFullYear()} Callyout. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
